import timg1 from "../images/team/sa-team02.png";
import timg2 from "../images/team/sa-team03.png";
import timg3 from "../images/team/sa-team01.png";
import timg4 from "../images/team/sa-team04.png";
import timg5 from "../images/team/sa-team05.png";
import timg6 from "../images/team/roshan.png";
import timg7 from "../images/team/sa-team07.png";
import timg8 from "../images/team/OM_G_2.png";
import timg9 from "../images/team/sa-team09.png";
import timg10 from "../images/team/sa-team10.png";
import timg11 from "../images/team/sa-team11.png";
import timg12 from "../images/team/sa-team12.png";

const Teams = [
  {
    Id: "1",
    tImg: timg1,
    name: "Sachin K.",
    slug: "Sachin-Kaduskar",
    title: "Sales Head Marketing",
    exprience: "20 Years experience",
    rating: "5.0",
    li: "",
    ig: "#",
  },
  {
    Id: "2",
    tImg: timg2,
    name: "Pooja K.",
    slug: "pooja-kaduskar",
    title: "CEO(Graphics Designer)",
    exprience: "12 Years experience",
    rating: "5.0",
    li: "",
    ig: "#",
  },
  {
    Id: "3",
    tImg: timg3,
    name: "Pragya P.",
    slug: "pragya-poudyal",
    title: "Digital Marketing Manager",
    exprience: "2 Years experience",
    rating: "4.5",
    li: "https://www.linkedin.com/in/pragya-poudyal-profile?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app",
    ig: "https://www.instagram.com/itzme_prags/",
  },
  {
    Id: "4",
    tImg: timg4,
    name: "Priyanka S.",
    slug: "Priyanka-Shejwalkar",
    title: "PHP Developer",
    exprience: "2 Years experience",
    rating: "4.5",
    li: "",
    ig: "",
  },
  {
    Id: "5",
    tImg: timg5,
    name: "Prince K.",
    slug: "prince kanoujiya",
    title: "Senior PHP Developer",
    exprience: "3 Years experience",
    rating: "4.5",
    li: "",
    ig: "https://www.instagram.com/_reisender_prince_/",
  },
  {
    Id: "6",
    tImg: timg6,
    name: "Roshan B.",
    slug: "roshan-bachhav",
    title: "React + PHP Developer",
    exprience: "2 Years experience",
    rating: "4.5",
    li: "https://www.linkedin.com/in/roshan-bachhav/",
    ig: "https://www.instagram.com/mr.roshan_bachhav/",
  },
  {
    Id: "7",
    tImg: timg7,
    name: "Shankar G.",
    slug: "shankar-gavit",
    title: "PHP Developer",
    exprience: "2 Years experience",
    rating: "4.5",
    li: "https://www.linkedin.com/in/shankar-gavit-a122b0345?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    ig: "https://www.instagram.com/s.r.gavit/",
  },
  {
    Id: "8",
    tImg: timg8,
    name: "Om G.",
    slug: "Om Goralkar",
    title: "Graphics Designer",
    exprience: "2 Years experience",
    rating: "4.5",
    li: "#",
    ig: "https://www.instagram.com/om_goralkar.45/",
  },
  //   {
  //     Id: "8",
  //     tImg: timg8,
  //     name: "David wilson",
  //     slug: "David wilson",
  //     title: "SEO Project Manager",
  //     exprience: "18 Years experience",
  //     rating: "4.8",
  //   },
  //   {
  //     Id: "9",
  //     tImg: timg9,
  //     name: "Sophia turner",
  //     slug: "Sophia turner",
  //     title: "Link Building Manager",
  //     exprience: "10 Years experience",
  //     rating: "4.5",
  //   },
  //   {
  //     Id: "10",
  //     tImg: timg10,
  //     name: "Natalie brooks",
  //     slug: "Natalie brooks",
  //     title: "Senior SEO Strategist",
  //     exprience: "18 Years experience",
  //     rating: "4.9",
  //   },
  //   {
  //     Id: "11",
  //     tImg: timg11,
  //     name: "Brian johnson",
  //     slug: "Brian johnson",
  //     title: "Business Developer",
  //     exprience: "20 Years experience",
  //     rating: "4.8",
  //   },
  //   {
  //     Id: "12",
  //     tImg: timg12,
  //     name: "Maverick Phoenix",
  //     slug: "Maverick-Phoenix",
  //     title: "data analyst",
  //     exprience: "15 Years experience",
  //     rating: "4.9",
  //   },
];

export default Teams;
